import momentTimezone from 'moment-timezone';
import moment from 'moment';
import Cookies from 'universal-cookie';

const upsertSchedulePayload = (data) => {
  const cookies = new Cookies();

  const timezone = cookies.get('organization')?.timezone;

  const startedTime = moment.tz(data?.startedAt, timezone);
  const endedTime = moment.tz(data?.endedAt, timezone);

  const startAt = moment(data?.selectedDate)
    .clone()
    .set({ hour: startedTime?.hour(), minute: startedTime?.minute(), second: startedTime?.second() })
    .format('YYYY-MM-DDTHH:mm:ss');

  const endAt = moment(data?.selectedDate)
    .clone()
    .set({ hour: endedTime?.hour(), minute: endedTime?.minute(), second: endedTime?.second() })
    .format('YYYY-MM-DDTHH:mm:ss');

  const startedAt = momentTimezone.tz(startAt, timezone).utc().format('YYYY-MM-DD HH:mm:ss');
  const endedAt = momentTimezone.tz(endAt, timezone).utc().format('YYYY-MM-DD HH:mm:ss');

  const payload = {
    title: data.title,
    accountLivestreamId: data.accountLivestreamId.map((account) => account.value),
    scheduleType: 'Live',
    startedAt,
    endedAt,
    hostId: data?.hostId.map((host) => host.value),
    operatorId: data?.operatorId.map((operator) => operator.value),
    studioId: data?.studioId?.value,
  };

  return payload;
};

export default upsertSchedulePayload;
